/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs */



/**
* | output |
* | --- |
* | "Cannot create folder in this view" |
*
* @param {Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_create_folder_not_allowed_toast = /** @type {((inputs?: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de creer un dossier dans cette vue")
	if (locale === "de") return /** @type {LocalizedString} */ ("In dieser Ansicht kann kein Ordner erstellt werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile creare la cartella in questa vista")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В этом представлении невозможно создать папку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede crear una carpeta en esta vista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此视图中无法创建文件夹。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このビューではフォルダを作成できません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस व्यू में फ़ोल्डर नहीं बनाया जा सकता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não é possível criar pasta nesta visualização.")
	return /** @type {LocalizedString} */ ("Cannot create folder in this view")
});